import { createAction, createSlice } from "@reduxjs/toolkit";

// Deal Room switch on the Investor dashboard: false = VC, true = PE.
// Shared state because the toggle is surfaced in two places — the portfolio tab row and the
// InvestorMatch Criteria settings page — and both must show and set the same value.
export default function getDealRoomReducer(dealRoom = false) {
	const dealRoomSlice = createSlice({
		name: "dealRoom",
		initialState: { isOn: dealRoom },
		reducers: {
			setDealRoom: (state, action) => {
				return { ...state, isOn: !!action.payload };
			}
		}
	});

	return dealRoomSlice.reducer;
}

export const setDealRoom = createAction("dealRoom/setDealRoom");
